<app-breadcrumb [title]="'Desplazamientos'" [items]="['Pesv']"
  [active_item]="'Registro de desplazamientos'"></app-breadcrumb>

<div class="container-fluid">
  <div class="card shadow-sm border-0">
    <div class="card-header bg-primary text-white d-flex align-items-center">
      <i class="icofont icofont-location-pin me-2"></i>
      <h5 class="mb-0"><strong>REGISTRO DE DESPLAZAMIENTOS</strong></h5>
    </div>

    <div class="card-body">
      <ul ngbNav #desplazamientoTab="ngbNav" [(activeId)]="activeTab" class="nav-tabs">

        <!-- TAB 1: FORMULARIO -->
        <li [ngbNavItem]="1">
          <a ngbNavLink><strong><i class="icofont icofont-plus me-1"></i> FORMULARIO DESPLAZAMIENTO</strong></a>
          <ng-template ngbNavContent>
            <form [formGroup]="desplazamientoForm" (ngSubmit)="guardar()" class="pt-3" novalidate>
              <div class="card border-0 shadow-sm mb-3">
                <div class="card-body row g-3">

                  <div class="col-md-3">
                    <label class="form-label text-dark">N° documento: <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" formControlName="n_documento"
                      placeholder="Ej: DES-0001"
                      [class.is-invalid]="desplazamientoForm.get('n_documento')?.invalid && desplazamientoForm.get('n_documento')?.touched">
                  </div>

                  <div class="col-md-3">
                    <label class="form-label text-dark">Fecha: <span class="text-danger">*</span></label>
                    <input type="date" class="form-control" formControlName="fecha"
                      [class.is-invalid]="desplazamientoForm.get('fecha')?.invalid && desplazamientoForm.get('fecha')?.touched">
                  </div>

                  <div class="col-md-3">
                    <label class="form-label text-dark">Conductor:</label>
                    <ng-select [items]="colaboradores" bindLabel="nombreCompleto" bindValue="cedula"
                      [loading]="cargandoColaboradores" [searchable]="true" [clearable]="true"
                      placeholder="Seleccione un conductor..." formControlName="conductor_id">
                      <ng-template ng-option-tmp let-colaborador="item">
                        <div>{{ colaborador.nombreCompleto }} - {{ colaborador.cargo }}</div>
                      </ng-template>
                    </ng-select>
                  </div>

                  <div class="col-md-3">
                    <label class="form-label text-dark">Vehículo:</label>
                    <ng-select [items]="vehiculos" bindLabel="placa" bindValue="placa"
                      [loading]="cargandoVehiculos" [searchable]="true" [clearable]="true"
                      placeholder="Seleccione un vehículo..." formControlName="vehiculo_id">
                    </ng-select>
                  </div>

                  <div class="col-md-3">
                    <label class="form-label text-dark">Origen: <span class="text-danger">*</span></label>
                    
                    <ng-select [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN"
                      [loading]="false" [searchable]="true" [clearable]="true"
                      placeholder="Seleccione un municipio..." formControlName="origen">
                    </ng-select>
                  </div>

                  <div class="col-md-3">
                    <label class="form-label text-dark">Destino: <span class="text-danger">*</span></label>

                    <ng-select [items]="municipios" bindLabel="MUNICIPIO" bindValue="IDMUN"
                      [loading]="false" [searchable]="true" [clearable]="true"
                      placeholder="Seleccione un municipio..." formControlName="destino">
                    </ng-select>
                  </div>

                  <div class="col-md-3">
                    <label class="form-label text-dark">Ruta:</label>
                      <ng-select [items]="tiposVia" bindLabel="nombre" bindValue="id"
                        [loading]="false" [searchable]="true" [clearable]="true"
                        placeholder="Seleccione un tipo de vía..." formControlName="ruta">
                      </ng-select>
                  </div>

                  <div class="col-md-3">
                    <label class="form-label text-dark">Hora salida programada:</label>
                    <input type="time" class="form-control" formControlName="hora_salida_programada">
                  </div>

                  <div class="col-md-3">
                    <label class="form-label text-dark">Hora llegada programada:</label>
                    <input type="time" class="form-control" formControlName="hora_llegada_programada">
                  </div>

                  <div class="col-md-3">
                    <label class="form-label text-dark">Hora salida real:</label>
                    <input type="time" class="form-control" formControlName="hora_salida_real">
                  </div>

                  <div class="col-md-3">
                    <label class="form-label text-dark">Hora llegada real:</label>
                    <input type="time" class="form-control" formControlName="hora_llegada_real">
                  </div>

                  <div class="col-md-3">
                    <label class="form-label text-dark">Kilometraje inicial:</label>
                    <input type="number" min="0" class="form-control" formControlName="kilometraje_inicial">
                  </div>

                  <div class="col-md-3">
                    <label class="form-label text-dark">Kilometraje final:</label>
                    <input type="number" min="0" class="form-control" formControlName="kilometraje_final"
                      [class.is-invalid]="desplazamientoForm.hasError('kmInvalido') && desplazamientoForm.get('kilometraje_final')?.touched">
                    <div class="invalid-feedback"
                      *ngIf="desplazamientoForm.hasError('kmInvalido') && desplazamientoForm.get('kilometraje_final')?.touched">
                      No puede ser menor al kilometraje inicial.
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-6">
                    <label class="form-label text-dark">Motivo del desplazamiento</label>
                    <textarea class="form-control" rows="3" formControlName="motivo"></textarea>
                  </div>


                  <div class="col-md-6">
                    <label class="form-label text-dark">Observaciones</label>
                    <textarea class="form-control" rows="3" formControlName="observaciones"></textarea>
                  </div>

                </div> <!-- cierre del row -->
              </div>

              <div class="d-flex justify-content-center gap-2 mt-4">
                <button type="submit" class="btn btn-primary px-4" [disabled]="guardando">
                  <span *ngIf="!guardando">
                    <i class="icofont icofont-save me-1"></i>{{ modoEdicion ? 'Actualizar' : 'Guardar' }}
                  </span>
                  <span *ngIf="guardando">
                    <span class="spinner-border spinner-border-sm me-1"></span>Guardando...
                  </span>
                </button>
                <button type="button" class="btn btn-secondary px-4" *ngIf="modoEdicion" (click)="cancelarEdicion()">
                  <i class="icofont icofont-close me-1"></i>Cancelar edición
                </button>
              </div>
            </form>
          </ng-template>
        </li>

        <!-- TAB 2: LISTADO -->
        <li [ngbNavItem]="2">
          <a ngbNavLink><strong><i class="icofont icofont-listine-dots me-1"></i> LISTADO DESPLAZAMIENTOS</strong></a>
          <ng-template ngbNavContent>
            <div class="card card-absolute rounded mt-3 border-0 shadow-sm">
              <div class="card-body pt-3">

                <div *ngIf="cargandoListado" class="text-center py-4">
                  <div class="spinner-border text-primary" role="status"></div>
                  <p class="mt-2 mb-0">Cargando desplazamientos...</p>
                </div>

                <div class="row mb-3 align-items-center" *ngIf="!cargandoListado">
                  <div class="col-md-3">
                    <select class="form-select" [(ngModel)]="filtroEstado" (change)="aplicarFiltro()">
                      <option [ngValue]="null">Todos</option>
                      <option [ngValue]="1">Activos</option>
                      <option [ngValue]="0">Inactivos</option>
                    </select>
                  </div>
                  <div class="col-md-4 ms-auto">
                    <div class="input-group">
                      <input type="text" class="form-control"
                        placeholder="Buscar por documento, conductor, placa, origen..." [(ngModel)]="filtro"
                        (input)="aplicarFiltro()">
                      <span class="input-group-text"><i class="fa fa-search"></i></span>
                    </div>
                  </div>
                </div>

                <div *ngIf="!cargandoListado" class="table-responsive mt-2">
                  <ng-container *ngIf="desplazamientosFiltrados.length > 0; else sinDatos">
                    <table id="tblDesplazamientos" class="table table-bordered table-hover align-middle">
                      <thead class="bg-primary text-white">
                        <tr>
                          <th class="text-center">N° DOCUMENTO</th>
                          <th class="text-center">FECHA</th>
                          <th class="text-center">CONDUCTOR</th>
                          <th class="text-center">VEHÍCULO</th>
                          <th class="text-center">ORIGEN</th>
                          <th class="text-center">DESTINO</th>
                          <th class="text-center">SALIDA REAL</th>
                          <th class="text-center">LLEGADA REAL</th>
                          <th class="text-center">KM RECORRIDOS</th>
                          <th class="text-center">ESTADO</th>
                          <th class="text-center">ACCIONES</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          *ngFor="let d of desplazamientosFiltrados | paginate: { itemsPerPage: pageSize, currentPage: page }">
                          <td class="text-center">{{ d.n_documento }}</td>
                          <td class="text-center">{{ d.fecha | date:'dd/MM/yyyy' }}</td>
                          <td class="text-center text-uppercase">{{ d.ConductorDesplazamientoData?.nombreCompleto }}</td>
                          <td class="text-center text-uppercase">{{ d.vehiculo_id }}</td>
                          <td class="text-center">{{ d.PesvOrigenDesplazamientosData?.MUNICIPIO }}</td>
                          <td class="text-center">{{ d.PesvDestinoDesplazamientosData?.MUNICIPIO }}</td>
                          <td class="text-center">{{ d.hora_salida_real ? (d.hora_salida_real | slice:0:5) : '-' }}</td>
                          <td class="text-center">{{ d.hora_llegada_real ? (d.hora_llegada_real | slice:0:5) : '-' }}</td>
                          <td class="text-center">{{ kmRecorridos(d) }}</td>
                          <td class="text-center">
                            <span class="badge rounded-pill" [ngClass]="{
                                'bg-success': d.estado === 1,
                                'bg-secondary': d.estado !== 1
                              }">
                              {{ d.estado === 1 ? 'ACTIVO' : 'INACTIVO' }}
                            </span>
                          </td>
                          <td class="text-center">
                            <div class="d-flex justify-content-center gap-1">
                              <button class="btn btn-sm btn-outline-info rounded-pill btn-rounded"
                                ngbTooltip="Ver Riesgos" (click)="verRiesgos(d)">
                                <i class="icofont icofont-warning" style="font-size:.85rem;"></i>
                              </button>
                              <button class="btn btn-sm btn-outline-warning rounded-pill btn-rounded"
                                ngbTooltip="Ver Puntos Críticos" (click)="verPuntosCriticos(d)">
                                <i class="icofont icofont-warning-alt" style="font-size:.85rem;"></i>
                              </button>
                               <button class="btn btn-sm btn-outline-primary rounded-pill btn-rounded"
                                ngbTooltip="Ver Requisitos" (click)="verRequisitos(d)">
                                <i class="icofont icofont-list" style="font-size:.85rem;"></i>
                              </button>
                              
                              <button class="btn btn-sm btn-outline-dark rounded-pill btn-rounded"
                                ngbTooltip="Ver Seguimientos" (click)="verSeguimientos(d)">
                                <i class="icofont icofont-eye" style="font-size:.85rem;"></i>
                              </button>
                              <button class="btn btn-sm btn-outline-secondary rounded-pill btn-rounded"
                                ngbTooltip="Ver Novedades" (click)="verNovedades(d)">
                                <i class="icofont icofont-notification" style="font-size:.85rem;"></i>
                              </button>
                              <button class="btn btn-sm btn-outline-info rounded-pill btn-rounded"
                                ngbTooltip="Ver Cierre" (click)="verCierre(d)">
                                <i class="icofont icofont-check-circled" style="font-size:.85rem;"></i>
                              </button>
                              <button class="btn btn-sm btn-outline-primary rounded-pill btn-rounded"
                                ngbTooltip="Editar" *ngIf="d.estado === 1" (click)="editar(d)">
                                <i class="icofont icofont-pencil" style="font-size:.85rem;"></i>
                              </button>
                              <button class="btn btn-sm btn-outline-danger rounded-pill btn-rounded"
                                ngbTooltip="Inactivar" *ngIf="d.estado === 1" (click)="inactivar(d)">
                                <i class="icofont icofont-close" style="font-size:.85rem;"></i>
                              </button>
                              <button class="btn btn-sm btn-outline-success rounded-pill btn-rounded"
                                ngbTooltip="Activar" *ngIf="d.estado !== 1" (click)="activar(d)">
                                <i class="icofont icofont-check" style="font-size:.85rem;"></i>
                              </button>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                    </table>

                    <div class="d-flex justify-content-between align-items-center mt-4">
                      <div class="d-flex align-items-center">
                        <label class="me-2">Mostrar:</label>
                        <select class="form-select w-auto" [(ngModel)]="pageSize" (change)="page = 1">
                          <option *ngFor="let size of [5, 10, 20, 50, 100]" [value]="size">{{ size }}</option>
                        </select>
                        <span class="ms-2">registros por página</span>
                      </div>
                      <div class="text-center flex-grow-1">
                        Total Registros: <a class="badge badge-primary"><b>{{ desplazamientosFiltrados.length || 0
                            }}</b></a>
                      </div>
                      <div class="text-end">
                        <pagination-controls (pageChange)="page = $event" [maxSize]="5" [directionLinks]="true"
                          [autoHide]="true" previousLabel="Anterior" nextLabel="Siguiente"></pagination-controls>
                      </div>
                    </div>
                  </ng-container>

                  <ng-template #sinDatos>
                    <div class="text-center py-4 text-primary">No hay desplazamientos registrados.</div>
                  </ng-template>
                </div>

                <div class="mt-4">
                  <div class="btn-showcase text-center">
                    <button class="btn btn-outline-success-2x" type="button" ngbTooltip="Exportar a Excel"
                      (click)="exportarExcel('tblDesplazamientos','listado_desplazamientos')">
                      <i class="icofont icofont-file-excel"></i> EXCEL
                    </button>
                    <button class="btn btn-outline-danger-2x" type="button" ngbTooltip="Exportar a PDF"
                      (click)="exportToPDF('tblDesplazamientos','listado_desplazamientos','Listado de desplazamientos')">
                      <i class="icofont icofont-file-pdf"></i> PDF
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </ng-template>
        </li>
      </ul>

      <div [ngbNavOutlet]="desplazamientoTab" class="mt-2"></div>
    </div>
  </div>
</div>